import { render, staticRenderFns } from "./AplicacionesList.vue?vue&type=template&id=f9235db6&"
import script from "./AplicacionesList.vue?vue&type=script&lang=js&"
export * from "./AplicacionesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports